import { gql } from '@apollo/client';

export const GET_SITE_SETTINGS = gql`
  query GetSiteSettings {
    siteSettings {
      address
      city
      phone
      whatsapp
      primaryEmail
      website
      facebookUrl
      instagramUrl
      twitterUrl
      linkedinUrl
      establishedLabel
      brandStatement
      newsletterTagline
      quickLinks { id label path sortOrder }
      trustBadges { id icon label sub sortOrder }
    }
  }
`;

export const SUBSCRIBE_NEWSLETTER = gql`
  mutation SubscribeNewsletter($email: String!) {
    subscribeNewsletter(email: $email) {
      success
      message
    }
  }
`;